<template>
  <fccModal
    centered
    idModal="listaPermissao"
    size="lg"
    titleModal="Permissões"
    escondeFooter
    travaEsc
    travaBack
  >
    <div id="printando">
      <div class="text-right w-100 d-flex d-flex justify-content-between mb-2">
        <h5 class="font-weight-bold w-75 text-left">{{ title }} {{ nomeAdmin }}</h5>
        <fcc-button @click="printElement('printando')"> Imprimir </fcc-button>
      </div>
      <!-- TABELA DE GRUPO -->
      <div v-if="TipoTabela == '1'" class="mb-4">
        <div class="titlePage mb-3">
          {{ titlePage }}
        </div>
        <div v-if="dataTable.length > 0">
          <fccTable hover striped :fields="fieldsGrupo" responsive :items="dataTable"> </fccTable>
        </div>
        <p v-else class="font-weight-bold text-danger">{{ respostaNegativa }}</p>
      </div>
      <!-- TABELA DE USUARIO -->
      <div v-if="TipoTabela == '2'" class="mb-5">
        <div class="titlePage mb-3">
          {{ titlePage }}
        </div>
        <div v-if="dataTable.length > 0">
          <fccTable hover striped :fields="fieldsUsuario" responsive :items="dataTable"> </fccTable>
        </div>
        <p v-else class="font-weight-bold text-danger">{{ respostaNegativa }}</p>
      </div>
      <fccTable
        hover
        striped
        :fields="fieldsPermissao"
        :items="DataItem"
        responsive
        titlePage="Permissões"
      >
        <template #objpermissoes="{ row, value }">
          <!-- PRIMEIRO NIVEL -->
          <font-awesome-icon icon="align-justify" size="sm" />
          <span class="font-weight-bold ml-2">{{ row.objnome }} - </span>
          <span
            class="text-success border rounded m-1 px-1"
            pill
            v-for="item in value"
            :key="item.objpermid"
          >
            {{ item.objpermdescricao }}
          </span>
          <!-- SEGUNDO NIVEL -->
          <b-row v-for="(item, index) in row.objparent" class="ml-2" :key="index">
            <b-col cols="12" class="my-1 mt-3">
              <font-awesome-icon icon="check" size="sm" /> {{ item.objnome }}:
            </b-col>
            <b-col cols="12">
              <!-- PERMISSÕES -->
              <span
                class="text-success border rounded m-1 px-1"
                pill
                v-for="permissao in item.objpermissoes"
                :key="permissao.objpermid"
              >
                {{ permissao.objpermdescricao }}
              </span>
            </b-col>
            <b-col cols="12" class="ml-4 mt-3">
              <!-- TERCEIRO NIVEL -->
              <b-row v-for="(itemObg, index) in item.objparent" :key="index">
                <b-col cols="12">
                  <font-awesome-icon icon="caret-right" size="sm" />
                  {{ itemObg.objnome }}
                </b-col>
                <b-col cols="12">
                  <!-- PERMISSÕES -->
                  <span
                    class="text-success border rounded m-1 px-1"
                    pill
                    v-for="permissao in itemObg.objpermissoes"
                    :key="permissao.objpermid"
                  >
                    {{ permissao.objpermdescricao }}
                  </span>
                </b-col>
                <b-col cols="12" class="ml-4 mt-3">
                  <!-- QUARTO NIVEL -->
                  <b-row v-for="(itemObg, index) in itemObg.objparent" :key="index">
                    <b-col cols="12">
                      <font-awesome-icon icon="ellipsis-v" size="sm" />
                      {{ itemObg.objnome }}
                    </b-col>
                    <b-col cols="12">
                      <!-- PERMISSÕES -->
                      <span
                        class="text-success border rounded m-1 px-1"
                        pill
                        v-for="permissao in itemObg.objpermissoes"
                        :key="permissao.objpermid"
                      >
                        {{ permissao.objpermdescricao }}
                      </span>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
      </fccTable>
    </div>
  </fccModal>
</template>
<script>
// import axios from 'axios'
export default {
  name: 'fccPermissoes',
  props: {
    title: String,
    DataItem: Array,
    dataTable: Array,
    nomeAdmin: String,
    titlePage: String,
    TipoTabela: String,
    respostaNegativa: String
  },
  data() {
    return {
      fieldsPermissao: [{ key: 'objpermissoes', label: 'Permissões', type: 'slot' }],
      fieldsGrupo: [
        { key: 'usuid', label: 'Usuário', sortable: true, active: true },
        { key: 'usucompnome', label: 'Nome', sortable: true, active: true }
      ],
      fieldsUsuario: [
        { key: 'pernome', label: 'Grupos', sortable: true, active: true },
        { key: 'perdescricao', label: 'Descrição', sortable: true, active: true }
      ]
    }
  }
}
</script>